import { render, staticRenderFns } from "./stateDetailView.vue?vue&type=template&id=3935f085&scoped=true&"
import script from "./stateDetailView.vue?vue&type=script&lang=ts&"
export * from "./stateDetailView.vue?vue&type=script&lang=ts&"
import style0 from "./stateDetailView.vue?vue&type=style&index=0&id=3935f085&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3935f085",
  null
  
)

export default component.exports